module.exports = __webpack_public_path__ + "static/media/xd.a7501b88.png";